//#region src/typeUtils.ts
function joinDestructors(destructors) {
	return () => {
		destructors.forEach((destructor) => destructor());
	};
}
async function runDestructorsParallel(destructors) {
	(await Promise.allSettled(destructors.map((d) => d()))).forEach((r) => {
		if (r.status === "rejected") console.error("Destructor error", r.reason);
	});
}
let Spans;
(function(_Spans) {
	function includes(reference, test) {
		return reference[0] <= test[0] && reference[1] >= test[1];
	}
	_Spans.includes = includes;
})(Spans || (Spans = {}));
function unreachable(value) {
	throw new Error("Unreachable code reached: " + JSON.stringify(value));
}
const tagSymbol = Symbol("tag");
function tag(value) {
	return value;
}
function untag(value) {
	return value;
}

//#endregion
export { Spans, joinDestructors, runDestructorsParallel, tag, tagSymbol, unreachable, untag };